<div class="task-panel">

  <!-- Header -->
  <div fxLayout="row" fxLayoutAlign="space-between center" class="panel-header">
    <h3 fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
      <mat-icon>task_alt</mat-icon>
      Tasks
      <span class="count-badge" *ngIf="tasks.length > 0">{{ tasks.length }}</span>
    </h3>
    <button mat-raised-button color="primary" (click)="toggleCreateForm()">
      <mat-icon>{{ showCreateForm ? 'close' : 'add' }}</mat-icon>
      {{ showCreateForm ? 'Cancel' : 'New Task' }}
    </button>
  </div>

  <!-- Create Form -->
  <div *ngIf="showCreateForm" class="create-form" [formGroup]="taskForm">
    <div fxLayout="column" fxLayoutGap="12px">

      <mat-form-field appearance="outline">
        <mat-label>Task Title *</mat-label>
        <input matInput formControlName="title" placeholder="Enter task title">
        <mat-error *ngIf="taskForm.controls.title.errors?.required">Title is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Description</mat-label>
        <textarea matInput formControlName="description" rows="2"
                  placeholder="Optional description"></textarea>
      </mat-form-field>

      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="12px">
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>Assign To *</mat-label>
          <mat-select formControlName="assignedTo" (selectionChange)="onAssigneeChange($event.value)">
            <mat-option *ngFor="let user of userList" [value]="user.id ?? user.userId">
              {{ user.name ?? user.userName }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="taskForm.controls.assignedTo.errors?.required">Assignee required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex>
          <mat-label>Priority</mat-label>
          <mat-select formControlName="priority">
            <mat-option *ngFor="let p of priorities" [value]="p">{{ p }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="12px">
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>Due Date & Time *</mat-label>
          <input matInput [matDatepicker]="duePicker" formControlName="dueDateTime">
          <mat-datepicker-toggle matSuffix [for]="duePicker"></mat-datepicker-toggle>
          <mat-datepicker #duePicker></mat-datepicker>
          <mat-error *ngIf="taskForm.controls.dueDateTime.errors?.required">Due date required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex>
          <mat-label>Reminder Before (min)</mat-label>
          <mat-select formControlName="reminderBeforeMinutes">
            <mat-option [value]="15">15 min</mat-option>
            <mat-option [value]="30">30 min</mat-option>
            <mat-option [value]="60">1 hour</mat-option>
            <mat-option [value]="1440">1 day</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div fxLayoutAlign="end center" fxLayoutGap="8px">
        <button mat-stroked-button (click)="toggleCreateForm()">Cancel</button>
        <button mat-raised-button color="primary"
                [disabled]="taskForm.invalid || saving"
                (click)="submitTask()">
          <mat-spinner *ngIf="saving" diameter="18" style="display:inline-block"></mat-spinner>
          <span *ngIf="!saving">Create Task</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Task List -->
  <div class="task-list">

    <div *ngFor="let task of tasks; trackBy: trackByTaskId" class="task-card">

      <div fxLayout="row" fxLayoutAlign="space-between start">

        <!-- Left: status dot + title -->
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
          <div class="status-dot" [style.background]="statusColor(task.status)"
               [matTooltip]="task.status"></div>
          <div>
            <div class="task-title">{{ task.title }}</div>
            <div class="task-meta">
              <mat-icon class="meta-icon">person_outline</mat-icon>
              {{ task.assignedToName }}
              &nbsp;·&nbsp;
              <mat-icon class="meta-icon">event</mat-icon>
              {{ task.dueDateTime | date:'dd MMM yyyy' }}
              &nbsp;·&nbsp;
              <span class="priority-chip" [class]="'priority-' + task.priority?.toLowerCase()">
                {{ task.priority }}
              </span>
            </div>
            <div *ngIf="task.description" class="task-desc">{{ task.description }}</div>
          </div>
        </div>

        <!-- Right: actions -->
        <button mat-icon-button [matMenuTriggerFor]="taskMenu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #taskMenu="matMenu">
          <button mat-menu-item *ngIf="task.status !== 'COMPLETED'" (click)="completeTask(task.id)">
            <mat-icon>check_circle</mat-icon> Mark Complete
          </button>
          <button mat-menu-item (click)="deleteTask(task.id)">
            <mat-icon>delete_outline</mat-icon> Delete
          </button>
        </mat-menu>

      </div>

    </div><!-- /task-card -->

    <div *ngIf="tasks.length === 0" class="empty-state">
      <mat-icon>assignment_turned_in</mat-icon>
      <p>No tasks yet. Create the first one!</p>
    </div>

  </div><!-- /task-list -->

</div>
